import {
  api_get,
  api_post,
  single_get,
  single_post,
  stringfy_post,
  single_stringfy_post
} from '@/utils/http'

const PREFIX = '/cguardian/api'

// 获取工作台内容管理列表
async function getMyResource(status: string, page: number, pageSize: number) {
  const res = await api_get(`${PREFIX}/resource/get-my-resource`, {
    status,
    page_num: page,
    page_size: pageSize
  })
  let list = []
  let total = 0

  if (res.success) {
    list = res.data.contents.map((item, index) => {
      return {
        operation: item.is_published,
        contentTitle: item.title,
        key: index,
        ...item
      }
    })
    total = res.data.count
  }

  return { list, total }
}

// 自媒体 / 新增 & 编辑
interface Resource {
  name: string // 文件名
  url: string // 文件地址
}

interface EditResourcesOpts {
  resource_id?: string
  business_type: number // 资源来源
  category: number // 分类
  account_name: string // 账户名称
  title: string // 内容标题
  source: number // 业务方
  publish_at: string // 预计发布日期
  operator: string // 运营负责人
  resource_data: Resource[]
}

async function editResources(options: EditResourcesOpts) {
  const res = await stringfy_post(`${PREFIX}/resource/edit-resource`, options)
  return res
}

// 自媒体 / 标记为已发布
async function publishResource(id: string) {
  const res = await api_post(`${PREFIX}/resource/mark-publish`, {
    resource_id: id
  })

  if (res.success) {
    return res
  }
}

export { getMyResource, editResources, publishResource }
